import { NgClass } from '@angular/common';
import { Component, effect, ElementRef, inject, input, linkedSignal, output, viewChild } from '@angular/core';
import { disabled, form, FormField, required, validate } from '@angular/forms/signals';
import { MatError, MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { NgxMaskDirective } from 'ngx-mask';

import { NotificationsService } from '../../dialogs/notifications.service';

export interface InlineInputMask {
  mask: string;
  placeholder: string;
}

@Component({
  imports: [MatFormField, FormField, NgxMaskDirective, MatInput, MatIcon, MatSuffix, MatError, NgClass],
  selector: 'avs-inline-input',
  styleUrl: './inline-input.component.scss',
  templateUrl: './inline-input.component.html',
})
export class InlineInputComponent {
  value = input<string | null>(null);
  type = input<'text' | 'email'>('text');
  label = input('');
  placeholder = input('');
  disabled = input(false);
  required = input(true);
  autofocus = input(false);
  showToast = input(true);
  fieldClass = input('');
  sizeClass = input('');
  mask = input<InlineInputMask>();
  updated = output<string>();

  protected readonly model = linkedSignal(() => this.value() ?? '');
  protected readonly field = form(this.model, path => {
    required(path, { when: () => this.required() });
    validate(path, ({ value }) => (value() && !value().trim() ? { kind: 'noSpaceAllowed' } : undefined));
    disabled(path, () => this.disabled());
  });

  private readonly inputRef = viewChild<ElementRef<HTMLInputElement>>('input');
  private readonly notifications = inject(NotificationsService);

  constructor() {
    effect(() => {
      if (this.autofocus()) {
        this.inputRef()?.nativeElement.focus();
      }
    });
  }

  protected onBlur() {
    if (this.field().invalid()) {
      this.model.set(this.value() ?? '');

      return;
    }

    if (this.model() !== (this.value() ?? '')) {
      this.updated.emit(this.model());
      if (this.showToast()) {
        this.notifications.showSuccessMessage(`${this.label()} updated`);
      }
    }
  }
}
